export default "__VITE_ASSET__Cd2Y189D__"